var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.779 1.137 5.807 3.22a.428.428 0 0 0 .322.234l2.3.333c.351.05.49.482.237.727l-1.664 1.62a.425.425 0 0 0-.123.378l.394 2.29a.427.427 0 0 1-.62.45L4.598 8.17a.419.419 0 0 0-.397 0L2.146 9.25a.427.427 0 0 1-.62-.45l.394-2.289a.425.425 0 0 0-.123-.378L.131 4.518a.426.426 0 0 1 .237-.726l2.3-.333a.431.431 0 0 0 .322-.235l1.025-2.087a.428.428 0 0 1 .767 0h-.003z"
  })));
};
export default SvgStar;